<div fxLayout="column" fxLayoutGap="1em">
    <div fxLayoutGap="4px" class="assignee input-wrapper default-select" fxLayout="column">
        <span class="label" *ngIf="label">{{ label }}</span>
        <div *ngIf="showSearchInput" fxLayout="row" fxLayoutGap="10px" fxLayoutGap.lt-md="10px" class="input-parent">
            <mat-form-field class="small-field users-rec-input" appearance="fill">
                <mat-select
                    [placeholder]="searchPlaceholder"
                    [formControl]="selectControl"
                    [multiple]="multiple"
                    [disabled]="disabled"
                    (selectionChange)="onSelectionChange($event)"
                >
                    <mat-select-trigger *ngIf="!multiple && selectControl.value">
                        {{ getDisplayValue(selectControl.value) }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <span>{{ getDisplayValue(option) }}</span>
                        </div>
                    </mat-option>
                </mat-select>
                <button
                    *ngIf="shouldShowClearButton()"
                    mat-icon-button
                    class="cancel-contact"
                    matSuffix
                    (click)="clearSelection()"
                    [disabled]="disabled"
                >
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px" *ngIf="hasSelectedOptions && showChips">
            <div
                class="admin-chip"
                fxLayout="row wrap"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
                *ngFor="let option of selectedOptions"
            >
                <span>{{ getDisplayValue(option) }}</span>
                <button *ngIf="!disabled" mat-icon-button matSuffix (click)="onRemoveOption(option)">
                    <mat-icon>cancel</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
